
import * as angular from "angular";

import { IPlot } from "@interfaces/IPlot";
import { PlotService } from "@services/plot.service";

import "./veriMapHeatMap.html";
import { IJourney } from "@interfaces/IJourney";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";

interface IVeriMapHeatMapComponentBindings {

    veriMap: IVeriMapComponent;

    plots: IPlot[];
    journeys: IJourney[];
    locations: google.maps.LatLng[] | google.maps.visualization.WeightedLocation[];

    fit: boolean;
}

class VeriMapHeatMapComponentController implements angular.IComponentController, IVeriMapHeatMapComponentBindings {
    veriMap: IVeriMapComponent;

    plots: IPlot[];
    journeys: IJourney[];
    locations: google.maps.LatLng[] | google.maps.visualization.WeightedLocation[];

    latLngs: google.maps.LatLng[] /*| google.maps.visualization.WeightedLocation[]*/;

    fit: boolean;

    // Heatmap settings
    heatMapLayer: google.maps.visualization.HeatmapLayer;

    static $inject = ["plotService"];

    constructor(
        private plotService: PlotService) {
    }

    $onInit() {
        this.veriMap.greyscale = true;
    }

    $onDestroy() {
        this.veriMap.greyscale = false;
        this.heatMapLayer.setMap(null);
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (onChangesObj["plots"] && this.plots /*&& this.heatMapLayer*/) {
            this.createPlotLatLngs();
        }

        if (onChangesObj["journeys"] && this.journeys /*&& this.heatMapLayer*/) {
            this.createJourneyLatLngs();
        }

        if (onChangesObj["locations"]) {
            this.latLngs = this.locations as google.maps.LatLng[];
        }

        this.showHeatMap();
    }

    //heatLayerCallback = (function (heatLayer: google.maps.visualization.HeatmapLayer) {
    //    this.setHeatMapLayer(heatLayer);

    //    this.showHeatMap();
    //}).bind(this);

    // -----------------------------

    private createJourneyLatLngs() {
        this.latLngs = [];

        this.journeys.forEach(journey => {
            if (!journey.LinePoints) {
                return;
            }

            journey.LinePoints.forEach(point => {
                this.latLngs.push(new google.maps.LatLng(point[0], point[1]));
            });
        });
    }

    private createPlotLatLngs() {

        if (this.plots == null || this.plots.length == 0) {
            console.error("createPlotLatLngs - No plots");
            return;
        }

        // For each vehicle get the days plots and turn that into lat lngs
        //var mvcArray = this.heatMapLayer.getData();
        //this.latLngs = this.plotService.convertPlotsToGoogleLatLng(this.plots);

        //latLngsForVehicle.forEach(latlng => {
        //    mvcArray.push(latlng);
        //});
    }

    private showHeatMap() {
        if (this.heatMapLayer == null) {
            //console.error("ShowHeatMap - NO LAYER");

            //return;
            this.createHeatMapLayer();
        }

        if (!this.latLngs || this.latLngs.length == 0) {
            console.warn("No latlngs for Heatmap");
        }

        this.heatMapLayer.setData(new google.maps.MVCArray(this.latLngs));

        this.fitMap(this.latLngs);
    }

    private createHeatMapLayer() {
        this.heatMapLayer = new google.maps.visualization.HeatmapLayer({
            //data: [],
            //dissipating: true,
            //radius: 50
            data: [],
            dissipating: true,
            maxIntensity: 20,
            radius: 6,
            opacity: 0.9,
            //dissipating: false
        });

        this.setHeatMapLayer();
    }

    private setHeatMapLayer() {

        this.heatMapLayer.setMap(this.veriMap.getMap());

        //this.heatMapLayer.set('radius', 20);
        //this.heatMapLayer.set('opacity', 0.5);
        //this.heatMapLayer.set('opacity', 0.8);

        // Change gradient
        var gradient = [
            'rgba(0, 255, 255, 0)',
            //'rgba(0, 255, 255, 1)',
            //'rgba(0, 191, 255, 1)',
            //'rgba(0, 127, 255, 1)',
            //'rgba(0, 63, 255, 1)',
            //'rgba(0, 0, 255, 0.25)',
            //'rgba(0, 0, 255, 0.5)',
            'rgba(0, 0, 255, 0.75)',
            'rgba(0, 0, 255, 1)',
            'rgba(0, 0, 223, 1)',
            'rgba(0, 0, 191, 1)',
            'rgba(0, 0, 159, 1)',
            'rgba(0, 0, 127, 1)',
            'rgba(63, 0, 91, 1)',
            'rgba(127, 0, 63, 1)',
            'rgba(191, 0, 31, 1)',
            'rgba(255, 0, 0, 1)'
        ];

        this.heatMapLayer.set('gradient', this.heatMapLayer.get('gradient') ? null : gradient);

        this.showHeatMap();
    }

    private fitMap(latLngsForVehicle: google.maps.LatLng[]) {
        if (this.veriMap == null || !this.fit) {
            return;
        }

        this.veriMap.fitMap(latLngsForVehicle);
    }
}

export class VeriMapHeatMapComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            plots: "<",
            journeys: "<",
            locations: "<",
            
            fit: "<"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapHeatMapComponentController;
        this.template = require("./veriMapHeatMap.html");
    }
}
